import axios, { AxiosRequestConfig } from "axios"
import { clearAuthUser, getAuthToken } from "./auth";
import { toast } from "react-toastify";

//apply base url for axios
//const API_URL = "https://stat-api.detdom.work/api"
const getApiBaseUrl = () => {
  const raw = (process.env.REACT_APP_BASE_API_URL || "").trim();
  const base = raw.replace(/\/+$/, "");
  return base ? `${base}/api` : "/api";
};

const API_URL = getApiBaseUrl();

const axiosApi = axios.create({
  baseURL: API_URL,
  // headers: {
  //   "Content-Type": "application/json",
  //   "ngrok-skip-browser-warning": "1"
  // }
})

type Theme = 'light' | 'dark' | 'colored';
const getToastTheme = (): Theme => {
  const storedTheme = localStorage.getItem("layoutTheme");
  return (storedTheme === 'light' || storedTheme === 'dark' || storedTheme === 'colored')
    ? storedTheme
    : 'light';
};

const getToastOptions = () => ({
  theme: getToastTheme(),
});

const getErrorMessage = (error: any) => {
  return (
    error?.response?.data?.error?.errorMessage ||
    error?.response?.data?.message ||
    error?.message ||
    "Unknown error"
  );
};

axiosApi.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    const headers: any = config.headers || {};
    if (typeof headers.set === "function") {
      headers.set("Authorization", `Bearer ${token}`);
    } else {
      headers.Authorization = `Bearer ${token}`;
    }
    config.headers = headers;
  }
  return config;
});

axiosApi.interceptors.response.use(
  function (response) {
    switch (response?.status) {
      case 200:
        //toast.success("Get Data Success", optionToast);
        break;
      case 204:
        toast.warning("No content", getToastOptions());
        break;
      default:
          break;
    }
    return response;
  },
    function (error) {

      if (error.response?.status) {
        //console.log(`status ${error.response?.data}`);
        switch (error.response?.status) {
          case 401:
            clearAuthUser();
            location.replace('/logout');
            break;
          case 403:
            //location.replace('/logout');
            //break;
          case 400:
          case 404:
          case 405:
            toast.error(getErrorMessage(error), getToastOptions());
            break;
          case 406:
            toast.error(getErrorMessage(error), getToastOptions());
            break;
          case 500:
            toast.error(getErrorMessage(error), getToastOptions());
            break;
          default:
            break;
        }
      } else {
        toast.error(getErrorMessage(error), getToastOptions());
      }
      return Promise.reject(error);
    }
)

export async function get<T = any>(url : string, config: AxiosRequestConfig = {}) {
  return axiosApi.get<T>(url, { ...config }).then(response => response.data);

}

export async function post<T = any>(url : string, data : any, config: AxiosRequestConfig = {}) {
  return axiosApi
    .post<T>(url, data, { ...config })
    .then(response => response.data)
}

export async function put<T = any>(url : string, data : any, config: AxiosRequestConfig = {}) {
  return axiosApi
    .put<T>(url, data, { ...config })
    .then(response => response.data)
}

export async function del<T = any>(url : string, config: AxiosRequestConfig = {}) {
  return axiosApi
    .delete<T>(url, { ...config })
    .then(response => response.data)
}
